import React, { useCallback, useState } from 'react'

// A live region is only spoken when its text changes, so an identical repeat
// would be silent. The zero-width space is toggled on and off to force the
// change and is not spoken.
const NUDGE = '​'

interface Props {
    message: string
}

export default function Announcer({ message }: Props) {
    return (
        <div className='j-announcer' role='status' aria-live='polite' aria-atomic='true'>
            {message}
        </div>
    )
}

export function useAnnouncer(): [string, (text: string) => void] {
    const [message, setMessage] = useState('')

    const announce = useCallback((text: string) => {
        if (!text) return
        setMessage(prev => (prev === text ? text + NUDGE : text))
    }, [])

    return [message, announce]
}

// Counts are only known in the browser, so the translated strings keep their
// <<name>> placeholders — same convention as applyParams on the server.
export function fillPlaceholders(template: string, values: { [key: string]: string | number }) {
    if (!template) return ''

    return Object.keys(values).reduce(
        (text, key) => text.split('<<' + key + '>>').join(String(values[key])),
        template
    )
}
